import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { MicroneedlingHero } from '../components/microneedling/MicroneedlingHero';
export function MicroneedlingPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2578">
      <Navigation data-id="element-2579" />
      <main data-id="element-2580">
        <MicroneedlingHero data-id="element-2581" />
      </main>
      <Footer data-id="element-2582" />
    </div>;
}